<template>
  <div id="register">
    <div class="register-content">
      <div class="register-screen">
        <div class="left">
          <img src="../assets/images/brands/holacon-logo.svg" height="48" alt="" />
          <div class="left-register-text">
            <div class="left-register-text-title text-center">{{ $t("auth.register.register") }}</div>
            <div class="left-register-text-content text-center">
              {{ $t("auth.register.registerText") }}
            </div>
          </div>
          <div class="left-input-area" @keyup.enter="register">
            <el-row :gutter="16">
              <el-col :span="12">
                <div class="left-register-input-box">
                  <label>{{ $t("auth.register.firstName") }}</label>
                  <el-input v-model="form.firstName" placeholder="..." autocomplete="off" :class="$inputError('firstName', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage("firstName", validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="left-register-input-box">
                  <label>{{ $t("auth.register.lastName") }}</label>
                  <el-input v-model="form.lastName" placeholder="..." autocomplete="off" :class="$inputError('lastName', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage("lastName", validationErrors) }}</span>
                </div>
              </el-col>
            </el-row>
            <div class="left-register-input-box">
              <label>{{ $t("auth.register.email") }}</label>
              <el-input prefix-icon="fas fa-envelope" v-model="form.email" autocomplete="off" placeholder="..." :class="$inputError('email', validationErrors)"></el-input>
              <span class="error">{{ $errorMessage("email", validationErrors) }}</span>
            </div>
            <el-row :gutter="16">
              <el-col :span="12">
                <div class="left-register-input-box">
                  <label>{{ $t("auth.register.password") }}</label>
                  <el-input prefix-icon="fas fa-lock" type="password" show-password autocomplete="off" v-model="form.password" placeholder="..." :class="$inputError('password', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage("password", validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="left-register-input-box">
                  <label>{{ $t("auth.register.repassword") }}</label>
                  <el-input prefix-icon="fas fa-lock" type="password" autocomplete="off" show-password v-model="form.passwordRetry" placeholder="..." :class="$inputError('passwordRetry', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage("passwordRetry", validationErrors) }}</span>
                </div>
              </el-col>
            </el-row>

            <div class="left-register-input-box" v-if="form.invitationCode != null">
              <label>{{ $t("auth.register.invitationCode") }}</label>
              <el-input v-model="form.invitationCode" placeholder="..." autocomplete="off" :class="$inputError('invitationCode', validationErrors)"></el-input>
              <span> {{ $t("auth.register.invitationCodeText") }}</span>
            </div>
          </div>
          <div class="left-register-checkbox-area">
            <div class="left-register-checkbox-container">
              <div class="left-checkbox " @click="agreement.one = !agreement.one" :class="{ active: agreement.one }"><i class="fas fa-check"></i></div>
              <div class="content" @click="openAgreementDialog(0)">
                <div class="agreement">{{ $t("auth.register.userAgreement") }}</div>
                <span v-if="$i18n.locale == 'tr'"> {{ $t("auth.register.readApprove") }}</span>
              </div>
            </div>
            <div class="left-register-checkbox-container">
              <div class="left-checkbox" @click="agreement.three = !agreement.three" :class="{ active: agreement.three }"><i class="fas fa-check"></i></div>
              <div class="content" @click="openAgreementDialog(2)">
                <div class="agreement">{{ $t("auth.register.privacyPolicy") }}</div>
                <span v-if="$i18n.locale == 'tr'"> {{ $t("auth.register.readApprove") }}</span>
              </div>
            </div>
            <div class="left-register-checkbox-container">
              <div class="left-checkbox" @click="agreement.two = !agreement.two" :class="{ active: agreement.two }"><i class="fas fa-check"></i></div>
              <div class="content" @click="openAgreementDialog(1)">
                <div class="agreement">{{ $t("auth.register.gdprAgreement") }}</div>
                <span v-if="$i18n.locale == 'tr'"> {{ $t("auth.register.readApprove") }}</span>
              </div>
            </div>
          </div>
          <div class="left-input-area">
            <vue-recaptcha sitekey="6LdNOBQjAAAAANW9arftXXlcgckEfMwEdG8R47Xs" ref="recaptcha" @expired="expiredToken" @verify="verifyMethod"></vue-recaptcha>
          </div>
          <div class="left-button-area">
            <div @click="goBackLogin">
              {{ $t("auth.register.existAccount") }} <span>{{ $t("auth.login.login") }} </span>
            </div>
            <el-button type="success" :disabled="!(agreement.one && agreement.two && agreement.three)" @click="register" class="left-login-button">
              <i class="fas fa-spinner  fa-spin" v-if="loading"></i>
              <div>{{ $t("auth.register.register") }}</div>
            </el-button>
          </div>
          <div class="left-language-selector">
            <div class="left-language-option " @click="changeLocale('tr')" :class="{ active: $i18n.locale == 'tr' }">TR</div>
            <div class="left-language-option " @click="changeLocale('en')" :class="{ active: $i18n.locale == 'en' }">EN</div>
          </div>
        </div>
        <div class="right"></div>
      </div>
      <el-dialog :visible.sync="policyDialog" :title="policy != null ? policy.title : 'Sözleşme'" class="large" custom-class="agreement-dialog" :destroy-on-close="true" :close-on-click-modal="false">
        <div class="custom-modal">
          <div class="modal-body" v-html="policy.details"></div>
          <div class="modal-footer" slot="footer">
            <div class="left-buttons">
              <el-button @click="policyDialog = false">{{ $t("organisation.billing.close") }}</el-button>
            </div>
            <div class="right-buttons">
              <el-button type="warning" @click="rejectPolicy(policy.type)">{{ $t("organisation.billing.cancel2") }}</el-button>
              <el-button type="primary" @click="acceptPolicy(policy.type)">{{ $t("organisation.billing.accept") }}</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";
import axios from "axios";
import moment from "moment/min/moment-with-locales";

export default {
  name: "Register",
  metaInfo: {
    title: "Register"
  },
  components: {
    VueRecaptcha
  },
  data() {
    return {
      policyDialog: false,
      policy: {},
      siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
      agreement: {
        one: false,
        two: false,
        three: false
      },
      timeout: null,
      form: {
        email: null,
        firstName: null,
        lastName: null,
        password: null,
        passwordRetry: null,
        invitationCode: null,
        recaptchaToken: null
      },
      loading: false,
      validationErrors: []
    };
  },
  async mounted() {
    if (this.$route.query.code != null && this.$route.query.code != undefined) {
      this.form.invitationCode = this.$route.query.code;
      var res = await axios.post("");
    }
  },
  methods: {
    rejectPolicy(type) {
      switch (type) {
        case 0:
          this.agreement.one = false;
          break;
        case 1:
          this.agreement.two = false;

          break;
        case 2:
          this.agreement.three = false;

          break;
      }
      this.policyDialog = false;
      this.policy = {};
    },
    acceptPolicy(type) {
      switch (type) {
        case 0:
          this.agreement.one = true;
          break;
        case 1:
          this.agreement.two = true;

          break;
        case 2:
          this.agreement.three = true;
          break;
      }
      this.policyDialog = false;
      this.policy = {};
    },
    async openAgreementDialog(type) {
      var res = await this.$store.dispatch("getPolicy", { type: type });
      if (!res.data.alert.hasError) {
        this.policy = res.data.data.item;
        this.policyDialog = true;
      }
    },
    expiredToken() {
      this.form.recaptchaToken = null;
      this.$refs.recaptcha.reset();
      this.loading = false;
    },
    verifyMethod(callback) {
      this.form.recaptchaToken = callback;
    },
    goUrl(link) {
      window.open(link, "_blank");
    },
    goBackLogin() {
      this.$router.push({ name: "login" });
    },
    async register() {
      this.loading = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.form.recaptchaToken == null) {
          this.$message.warning(this.$t("generic.recaptcha"));
          this.loading = false;
          return;
        }
        axios.defaults.headers["language"] = localStorage.getItem("lang");
        var res = await axios.post("login/signup", this.form);
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
          this.expiredToken();
          this.loading = false;
        } else {
          this.$store.commit("setToken", res.data.data.token);
          await this.$store.dispatch("getUser");
          this.$router.push({ path: "/?gaction=register" });
        }
        this.loading = false;
      }, 500);
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
      moment.locale(locale);
      localStorage.setItem("lang", locale);
      axios.defaults.headers["language"] = locale;
    }
  }
};
</script>
<style lang="less" scoped>
#register {
  .register-content {
    width: 100%;
    min-height: 100vh;
    background-image: url("../assets/images/backgrounds/login-bg.png");
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .register-screen {
      background-color: white;
      border-radius: 1rem;
      max-width: 900px;
      width: 900px;
      display: flex;
      overflow: hidden;
      filter: drop-shadow(0px 2px 10px rgba(41, 47, 59, 0.1));
      height: 80r0px;
      .left {
        .left-language-selector {
          max-width: 256px;
          width: 256px;
          height: 48px;
          align-self: center;
          background: #ffffff;
          padding: 8px;
          box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
          border-radius: 48px;
          display: flex;
          .left-language-option {
            width: 119px;
            height: 32px;
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            display: flex;
            align-items: center;
            cursor: pointer;
            justify-content: center;
            text-align: center;
            letter-spacing: 0.2px;
            border-radius: 48px;

            transition: all 0.5s;
            &.active {
              background: #268ea6;
              color: white;
              border-radius: 48px;
            }
          }
        }
        .left-login-button {
          width: 196px;
          border: none;
          background: #268ea6 !important;
          & > span {
            display: flex;
            justify-content: center;
            flex-direction: row;
            gap: 11px;
            font-style: normal;
            font-weight: 600;
            width: 100% !important;
            font-size: 16px;
            align-items: center;
            & > i {
              font-size: 16px !important;
            }
          }
          color: #ffffff;
        }
        .left-button-area {
          display: flex;
          align-items: center;
          & > div {
            & > span {
              font-weight: 500;
              text-decoration-line: underline;
              cursor: pointer;
              color: #268ea6;
            }
            color: #292f3b;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            letter-spacing: 0.2px;
            max-height: 40px;
          }

          justify-content: space-between;
        }
        .left-input-area {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        width: 568px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 1rem 3rem;
        .left-register-text {
          display: flex;
          flex-direction: column;
          gap: 8px;
          .left-register-text-title {
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            line-height: 36px;
            color: #292f3b;
            text-transform: capitalize;
          }
          .left-register-text-content {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: #8c929c;
          }
        }
        .left-register-checkbox-area {
          display: flex;
          flex-direction: column;
          gap: 8px;
          .left-register-checkbox-container {
            display: flex;
            align-items: center;
            height: 24px;
            & > .content {
              display: flex;
              cursor: pointer;
              align-items: center;
              gap: 5px;
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              letter-spacing: 0.2px;
              & > .agreement {
                text-decoration-line: underline;
                color: #268ea6;
              }
              & > span {
                font-weight: 400;
                text-decoration-line: unset;
                color: #292f3b;
              }
            }
            .left-checkbox {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 6px 4px;
              width: 24px;
              &.active {
                background: #268ea6;
                i {
                  display: block;
                }
              }
              background-color: #f1f3f6;
              height: 24px;
              border: 1px solid #c1e8f1;
              border-radius: 5px;
              i {
                display: none;
                color: white;
                width: 14.5px;
                height: 10px;
                font-size: 14.5px;
              }
            }
          }
        }
      }
      .right {
        width: 336px;
        background-image: url("../assets/images/backgrounds/holacon-side-column-image.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: auto;
      }
    }
  }
}
</style>
<style lang="less">
.agreement-dialog {
  max-width: 800px;
  max-height: 600px;
}
.agreement-content {
  max-height: 450px;
  overflow-y: auto;
  padding: 1rem;
}
.left-register-input-box {
  display: flex;
  gap: 8px;
  flex-direction: column;
  label {
    margin-bottom: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #505763;
  }
  .el-input {
    input {
      border: 1px solid #c8cdd3;
      background-color: white !important;
    }
    .el-input__icon.fas {
      font-size: 13px;
      color: #268ea6;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.left-register-button {
  width: 196px;
  border: none;
  background: #268ea6 !important;
  & > span {
    display: flex;
    justify-content: center;
    gap: 11px;
    font-style: normal;
    font-weight: 600;
    width: 100% !important;
    font-size: 16px;
    align-items: center;
    & > i {
      font-size: 16px !important;
    }
  }
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue